export default __webpack_public_path__ + "static/media/loader-orange.f8fc63fe.svg";